/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConsumerTaskStatus,
    ConsumerTaskStatusFromJSON,
    ConsumerTaskStatusFromJSONTyped,
    ConsumerTaskStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimplifyAllTaskView
 */
export interface SimplifyAllTaskView {
    /**
     * 
     * @type {string}
     * @memberof SimplifyAllTaskView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplifyAllTaskView
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplifyAllTaskView
     */
    firmId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplifyAllTaskView
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplifyAllTaskView
     */
    externalCommunicationId?: string;
    /**
     * 
     * @type {ConsumerTaskStatus}
     * @memberof SimplifyAllTaskView
     */
    status?: ConsumerTaskStatus;
    /**
     * 
     * @type {number}
     * @memberof SimplifyAllTaskView
     */
    progressPercentage?: number;
    /**
     * 
     * @type {Date}
     * @memberof SimplifyAllTaskView
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SimplifyAllTaskView
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SimplifyAllTaskView
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof SimplifyAllTaskView
     */
    processedCount?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimplifyAllTaskView
     */
    processedInterrogatoryIds?: Array<number> | null;
}

export function SimplifyAllTaskViewFromJSON(json: any): SimplifyAllTaskView {
    return SimplifyAllTaskViewFromJSONTyped(json, false);
}

export function SimplifyAllTaskViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimplifyAllTaskView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'firmId': !exists(json, 'firmId') ? undefined : json['firmId'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'externalCommunicationId': !exists(json, 'externalCommunicationId') ? undefined : json['externalCommunicationId'],
        'status': !exists(json, 'status') ? undefined : ConsumerTaskStatusFromJSON(json['status']),
        'progressPercentage': !exists(json, 'progressPercentage') ? undefined : json['progressPercentage'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
        'processedCount': !exists(json, 'processedCount') ? undefined : json['processedCount'],
        'processedInterrogatoryIds': !exists(json, 'processedInterrogatoryIds') ? undefined : json['processedInterrogatoryIds'],
    };
}

export function SimplifyAllTaskViewToJSON(value?: SimplifyAllTaskView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'firmId': value.firmId,
        'documentId': value.documentId,
        'externalCommunicationId': value.externalCommunicationId,
        'status': ConsumerTaskStatusToJSON(value.status),
        'progressPercentage': value.progressPercentage,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'totalItems': value.totalItems,
        'processedCount': value.processedCount,
        'processedInterrogatoryIds': value.processedInterrogatoryIds,
    };
}


